<template>
  <div class="vice-title">
    <span class="vertical"></span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ViceTitle"
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/global";
.vice-title {
  margin: 30px 0;
  display: flex;
  /*height: 50px;*/
  .vertical {
    /*margin-left: 30px;*/
    height: 21px;
    width: 6px;
    background: #479aed;
  }
  h3 {
    margin-left: 16px;
    font-size: 20px;
    color: $publicFontColor;
  }
}
</style>
